import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useSnackbar } from "notistack";
import { deleteBatchGroup } from "../../api/batch";

export function DeleteBatchGroupAction({
  id,
  name,
  onDeleted,
}: {
  id?: number;
  name: string;
  onDeleted?: () => void;
}) {
  const { enqueueSnackbar } = useSnackbar();
  const label = `Delete batch group for ${name}`;
  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        aria-label={label}
        data-testid="batch_delete_btn"
        onClick={() => {
          deleteBatchGroup(id)
            .then(() => {
              enqueueSnackbar("Batch successfully deleted!", {
                variant: "success",
              });
              onDeleted?.();
            })
            .catch((err) => console.log(err));
        }}
      >
        <DeleteOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
